<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            اضطرابات / انقطاعات في التدفقات المالية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            تحليل الانقطاعات المالية وأسبابها وأثرها
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-finance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">7/9</div>
          <div class="kpi-label">مرافق تعاني انقطاعاً</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">4.5 شهر</div>
          <div class="kpi-label">متوسط فترة الانقطاع</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">60%</div>
          <div class="kpi-label">الكادر يتأخر في الراتب</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">3</div>
          <div class="kpi-label">مرافق أوقفت خدمات بسبب التمويل</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">تحليل انقطاعات التدفقات المالية</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>تكرار الانقطاع</th>
            <th>مدة الانقطاع الأطول</th>
            <th>السبب الرئيسي</th>
            <th>الخدمات المتأثرة</th>
            <th>آلية التكيف</th>
            <th>الخطورة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.frequency }}</td>
            <td>{{ item.longestDuration }}</td>
            <td>{{ item.reason }}</td>
            <td>{{ item.affectedServices }}</td>
            <td>{{ item.copingMechanism }}</td>
            <td>
              <v-chip
                :color="riskColor(item.risk)"
                size="small"
                variant="flat"
                >{{ item.risk }}</v-chip
              >
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    frequency: "3-4 مرات/سنة",
    longestDuration: "6 أشهر",
    reason: "انقطاع صرف الوزارة",
    affectedServices: "رواتب + أدوية",
    copingMechanism: "تقليص الخدمات",
    risk: "شديد",
  },
  {
    name: "مستشفى الأمراض النفسية",
    frequency: "4-6 مرات/سنة",
    longestDuration: "9 أشهر",
    reason: "انقطاع صرف الوزارة",
    affectedServices: "كل الخدمات",
    copingMechanism: "تعليق خدمات",
    risk: "شديد",
  },
  {
    name: "مجمع الشيخ عثمان",
    frequency: "2-3 مرات/سنة",
    longestDuration: "3 أشهر",
    reason: "تأخر تحويل المنظمات",
    affectedServices: "الأدوية",
    copingMechanism: "احتياطي محدود",
    risk: "متوسط",
  },
  {
    name: "مركز كود العثماني",
    frequency: "1-2 مرة/سنة",
    longestDuration: "2 شهر",
    reason: "انقطاع صرف",
    affectedServices: "الوقود والأدوية",
    copingMechanism: "قروض غير رسمية",
    risk: "خفيف",
  },
  {
    name: "مركز الممدارة",
    frequency: "مرة/سنة",
    longestDuration: "شهر واحد",
    reason: "تأخر",
    affectedServices: "—",
    copingMechanism: "—",
    risk: "خفيف",
  },
  {
    name: "مركز المحاريق",
    frequency: "3-4 مرات/سنة",
    longestDuration: "4 أشهر",
    reason: "انقطاع صرف",
    affectedServices: "رواتب + وقود",
    copingMechanism: "تقليص",
    risk: "شديد",
  },
  {
    name: "مركز عبد القوي",
    frequency: "لا انقطاع",
    longestDuration: "—",
    reason: "—",
    affectedServices: "—",
    copingMechanism: "—",
    risk: "لا يوجد",
  },
  {
    name: "مركز ماري ستبوس",
    frequency: "منقطع كلياً",
    longestDuration: "12+ شهر",
    reason: "انتهاء دعم المنظمة",
    affectedServices: "كل الخدمات",
    copingMechanism: "إغلاق المرفق",
    risk: "شديد",
  },
  {
    name: "جمعية حقوق الطفل",
    frequency: "نادراً",
    longestDuration: "أسابيع",
    reason: "تأخر إداري",
    affectedServices: "—",
    copingMechanism: "—",
    risk: "خفيف",
  },
];

const riskColor = (value) => {
  if (value === "خفيف" || value === "لا يوجد") return "green";
  if (value === "متوسط") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
